import React, { useEffect, useState } from 'react';
import './category.scss';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { textConvertUrl } from '../../../core/hooks/textConvert';
import { svg_default_file_app } from '../../../core/hooks/assetsConstants';
import { useWordService, useWordCategoryService, useWordTagService, useWord_id_categoryService } from '../../../core/hooks/services/word.service';
import SearchGeneral from '../../../components/content/searchs/search_general/SearchGeneral';
import CardItemList from '../../../components/content/cards/card_item_list/CardItemList';
import CardItemCategory from '../../../components/content/cards/card_item_category/CardItemCategory';

export default function Category({ setPageTitle }: any) {

  const { title, tag } = useParams<{ title: string; tag?: string }>();
  const [article, setArticle] = useState<any | null>(null);
  const navigate = useNavigate();

  // Llamada al servicio de diccionario
  const { content, loading, error } = useWordService();
  const [dataWord, setDataWord] = useState({});
  const [idCategory, setIdCategory] = useState(0);

  const { content: contentWordCategory, loading: loadingWordCategory, error: errorWordCategory } = useWordCategoryService(0);
  const [dataWordCategory, setDataWordCategory] = useState<any[]>([]);

  const { content: contentWordNameTag, loading: loadingWordNameTag, error: errorWordNameTag } = useWordTagService(tag ? tag : '');
  const [dataWordNameTag, setDataWordNameTag] = useState<any[]>([]);

  useEffect(() => {

    // Función para obtener los datos de las palabras
    const fetchData = async () => {
      const result = await content();
      if (result) {
        setDataWord(result.data.word)
      }
    };

    // Función para obtener los datos de las palabras de categorias
    const fetchWordCategoryData = async () => {
      try {
        const result = await contentWordCategory();

        if (result && result.data && result.data.wordByCategory) {
          // Guarda los datos de las palabras en el estado
          setDataWordCategory(result.data.wordByCategory);
        } else {
          setDataWordCategory([]);
        }
      } catch (error) {
        console.error("Error fetching word data:", error);
        setDataWordCategory([]);
      }
    };

    fetchData();
    fetchWordCategoryData();
  }, []);


  // Busca el artículo una vez que los datos del diccionario están disponibles
  useEffect(() => {
    if (Array.isArray(dataWordCategory) && dataWordCategory.length > 0 && title) {
      const parsedTag = tag ? tag : null;

      // Busca el artículo en `dataWordCategory` usando `slug`
      const foundArticle = dataWordCategory.find((item: any) =>
        textConvertUrl(item.title) === title && (parsedTag === null || parsedTag)
      );
    
      if (foundArticle) {
        setIdCategory(foundArticle.id)
        setArticle(foundArticle);
        setPageTitle(foundArticle.title);
        document.title = `${foundArticle.title} | SeñaTech`;
      } else {
        navigate('/404', { replace: true });
      }
    }

    // Función para obtener los datos del diccionario por nombre de Tag
    if (tag) {
      const contentWordNameTagData = async () => {
        try {
          const result = await contentWordNameTag();

          if (result && result.data && result.data.word) {
            // Guarda los datos del diccionario en el estado
            setDataWordNameTag(result.data.word);
            console.log(result.data.word)
          } else {
            setDataWordNameTag([]);
          }
        } catch (error) {
          console.error("Error fetching word Tag data:", error);
          setDataWordNameTag([]);
        }
      };
      contentWordNameTagData();
    }

  }, [dataWordCategory, title, tag, navigate, setPageTitle, idCategory]);

  // Llamar a la galeria de datos por categoria
  const { content: contentWord_id_category, loading: loadingWord_id_category, error: errorWord_id_category } = useWord_id_categoryService(idCategory);
  const [dataWord_id_category, setDataWord_id_category] = useState<any[]>([]);

  useEffect(() => {
    const fetchDataWord_id_category = async () => {
      try {
        const result = await contentWord_id_category();
        if (result) {
          setDataWord_id_category(result.data.word);
        }
      } catch (error) {
        console.error("Error fetching gallery word data:", error);
      }
    };

    fetchDataWord_id_category();
  }, [idCategory]);


  if (loading || loadingWordCategory || loadingWord_id_category) return <div>Cargando...</div>;
  if (error || errorWordCategory || errorWord_id_category) return <div>Error al cargar los datos</div>;

  return (
    <section className="page content_category">
      {article && (
        <>
          <div className='title_content'>
            <h1 className='title'>Base de conocimiento</h1>
            <div className='search'>
              <SearchGeneral data={dataWord} showInitialResults={true} />
            </div>
          </div>

          <div className='info_content'>

            <div className='info'>
              <h1 className='title'>{tag ? <b className='tag'>{tag}</b> : article.title}</h1>

              {/* Condicion cuando es alfabetico */}
              {idCategory === 9999 && (
                <>
                  {/* Cuando es elementos de etiquetas */}
                  {tag && (
                    <div className='categories'>
                      {dataWordNameTag.map((item: any, index: number) => (
                        <div key={index} className='category'>
                          <Link to={`/a/${textConvertUrl(item.slug_word)}/${item.id_word}`} className='title'>
                            <p><img src={svg_default_file_app} width={30} alt="file" /> {item.name_word}</p>
                          </Link>
                        </div>
                      ))}
                    </div>

                  ) || (

                      // Cuando se muestran todas las categorias
                      <div className='alfabetics'>
                        {dataWord_id_category &&
                          <CardItemList data={dataWord_id_category} /> ||
                          <div>
                            No hay categorías para mostrar
                          </div>
                        }
                      </div>
                    )}
                </>

              ) || (

                  // Cuando es una categoria
                  <div className='categories'>
                    {dataWord_id_category.map((item: any, index: number) => (
                      <div key={index} className='category'>
                        <Link to={`/a/${textConvertUrl(item.slug_word)}/${item.id_word}`} className='title'>
                          <p><img src={svg_default_file_app} width={30} alt="file" /> {item.name_word}</p>
                        </Link>
                      </div>
                    ))}
                  </div>
                )}
            </div>

            <div className='category_content'>
              <CardItemCategory data={dataWordCategory} />
            </div>
          </div>
        </>
      )}
    </section>
  );
}
